/* NW sengeguide: tilvalg pr. materiale. Tilfoejet 28-08-2026.

   BAGGRUND: lagenColors og pudeColors i nw-sg-2.js er EEN global liste med
   bambusfarver og bambusbilleder. De skiftede aldrig med materialet. Paa et
   egyptisk saet stod der derfor ordret "Matchende boxlagen . Bambus . Hvid",
   med et bambusbillede, og kurven fik et bambuslagen.

   Samtidig blev sortimentet ikke solgt: egyptisk kuvertlagen til 599/799 og
   silkelagen findes aktive paa lager og blev aldrig tilbudt.

   Filen goer to ting:
   1) Skifter lagenColors, pudeColors, lagenTypes og lagenSizes ud efter materiale
      foer hver render, saa det viste passer til det anbefalede sengetoej.
   2) Eksponerer tabellerne til nw-sg-priser.js og nw-sg-kurv.js, saa pris,
      lager og kurv bruger de samme handles.

   HOER, AENDRET 31-08-2026 efter besked fra Mads: der kommer ingen hoerlagner.
   Foer stod hoer med tomme lister, saa lagen-raekken blev skjult helt. Det gav
   den dyreste anbefaling (1.199 til 1.999 kr) den laveste mersalgsvaerdi.
   Hoer faar nu det EGYPTISKE kuvertlagen tilbudt som det matchende lagen.

   VIGTIGT VED DET VALG: lagenet ER ikke hoer, og maa ikke kaldes hoer.
   nw-sg-tekst.js skriver saetets materialenavn ind i lagen-linjen, saa der ville
   komme til at staa "Hoer . Hvid . 90x200" paa et egyptisk lagen. Derfor
   eksponeres lagenMateriale, som nw-sg-tekst.js bruger i stedet naar den findes.
   Typens undertekst siger det ogsaa ligeud.

   HOERPUDEBETRAEK findes stadig ikke, og den raekke er stadig skjult. Saettet
   indeholder i forvejen pudebetraek. */
(function(){
  'use strict';

  var CDN_SUFFIX = '';

  var T = {
    bambus: {
      box: ["bambus-boxlagen-hvid","bambus-boxlagen-lys-beige","bambus-boxlagen-sand-90x200x35cm","bambus-boxlagen-taupe","kopi-af-bambus-boxlagen-khaki","bambus-boxlagen-mork-gra","bambus-boxlagen-lys-bla","bambus-boxlagen-lavendel"],
      kuvert: ["bambus-kuvertlagen","bambus-kuvertlagen-lys-beige","bambus-kuvertlagen-sand","bambus-kuvertlagen-taupe-2","kopi-af-bambus-kuvertlagen-khaki-180x200x20cm","bambus-kuvertlagen-mork-gra","bambus-kuvertlagen-lys-bla","bambus-kuvertlagen-lavendel"],
      lagenFarver: [
        {name:"Hvid",tone:"light",img:"bambus-boxlagen-hvid-140x200x35cm-212702.jpg?v=1736773192"},
        {name:"Lys beige",tone:"light",img:"bambus-boxlagen-lys-beige-140x200x35-376036.jpg?v=1736773244"},
        {name:"Sand",tone:"warm",img:"bambus-boxlagen-sand-140x200x35cm-182219.jpg?v=1736773212"},
        {name:"Taupe",tone:"warm",img:"bambus-boxlagen-taupe-140x200x35-895570.jpg?v=1736773219"},
        {name:"Khaki",tone:"green",img:"bambus-boxlagen-khaki-180x200x35cm-714681.jpg?v=1736773208"},
        {name:"Mørk grå",tone:"deep",img:"bambus-boxlagen-mork-gra-90x200x35cm-805150.jpg?v=1736773211"},
        {name:"Lys blå",tone:"light",img:"bambus-boxlagen-lys-bla-140x200x35cm-301104.jpg?v=1736773210"},
        {name:"Lavendel",tone:"light",img:"bambus-boxlagen-lavendel-90x200x35cm-414737.jpg?v=1736773244"}
      ],
      lagenTyper: [{id:"box",l:"Boxlagen",s:"35 cm - om hele madrassen"},{id:"kuvert",l:"Kuvertlagen",s:"20 cm - til topmadrassen"}],
      lagenStr: [{v:"90×200"},{v:"90×210"},{v:"120×200"},{v:"140×200"},{v:"160×200"},{v:"180×200"},{v:"180×210"},{v:"210×210"}],
      pb: ["bambus-pudebetraek-hvid","bambus-pudebetraek-lys-beige","bambus-pudebetraek-sand","bambus-pudebetraek-taupe","bambus-pudebetraek-khaki","bambus-pudebetraek-mork-gra","bambus-pudebetraek-lys-bla","bambus-pudebetraek-lavendel"],
      pbFarver: [
        {name:"Hvid",tone:"light",img:"bambus-pudebetraek-hvid-932809.jpg?v=1736773266"},
        {name:"Lys beige",tone:"light",img:"bambus-pudebetraek-lys-beige-707225.jpg?v=1736773242"},
        {name:"Sand",tone:"warm",img:"bambus-pudebetraek-sand-380704.jpg?v=1736773243"},
        {name:"Taupe",tone:"warm",img:"bambus-pudebetraek-taupe-311511.jpg?v=1736773240"},
        {name:"Khaki",tone:"green",img:"bambus-pudebetraek-khaki-932491.jpg?v=1736773264"},
        {name:"Mørk grå",tone:"deep",img:"bambus-pudebetraek-mork-gra-637413.jpg?v=1736773242"},
        {name:"Lys blå",tone:"light",img:"bambus-pudebetraek-lys-bla-577067.jpg?v=1736773241"},
        {name:"Lavendel",tone:"light",img:"bambus-pudebetraek-lavendel-939466.jpg?v=1736773236"}
      ],
      pbStr: [{v:"60×63"},{v:"50×70"}]
    },

    /* Egyptisk bomuld: kun kuvertlagen findes, i tre farver og to stoerrelser. */
    egyptisk: {
      box: null,
      kuvert: ["egyptisk-bomuld-kuvertlagen-hvid","egyptisk-bomuld-kuvertlagen-sand","egyptisk-bomuld-kuvertlagen-shitake"],
      lagenFarver: [
        {name:"Hvid",tone:"light",img:"Egyptisk_bomuld_kuvertlagen_i_hvid_-_Nordic_Weaving.png?v=1787903354"},
        {name:"Sand",tone:"warm",img:"Egyptisk_bomuld_kuvertlagen_Sand.png?v=1787042368"},
        {name:"Shitake",tone:"warm",img:"Egyptisk_bomuld_kuvertlagen_Shitake.png?v=1787042367"}
      ],
      lagenTyper: [{id:"kuvert",l:"Kuvertlagen",s:"20 cm - med elastik hele vejen rundt"}],
      lagenStr: [{v:"90×200"},{v:"180×200"}],
      pb: ["pudebetraek-egyptisk-bomuld-hvid","pudebetraek-egyptisk-bomuld-sand","pudebetraek-egyptisk-bomuld-shitake","pudebetraek-egyptisk-bomuld-laurel-oak","pudebetraek-egyptisk-bomuld-bla"],
      pbFarver: [
        {name:"Hvid",tone:"light",img:"pudebetraek-egyptisk-bomuld-hvid-6880698.jpg?v=1763185546"},
        {name:"Sand",tone:"warm",img:"pudebetraek-egyptisk-bomuld-sand-5865675.jpg?v=1764771253"},
        {name:"Shitake",tone:"warm",img:"pudebetraek-egyptisk-bomuld-shitake-9591035.jpg?v=1764771146"},
        {name:"Laurel Oak",tone:"green",img:"pudebetraek-egyptisk-bomuld-laurel-oak-4072068.jpg?v=1764771298"},
        {name:"Lys blå",tone:"light",img:"pudebetraek-egyptisk-bomuld-lys-bla-4703471.jpg?v=1763185546"}
      ],
      pbStr: [{v:"60×63"},{v:"50×70"}]
    },

    /* Silke: kun Navy blaa er paa lager. Ivory og Mocca er kladde eller udsolgt. */
    silke: {
      box: ["silke-boxlagen-navy-bla"],
      kuvert: ["silke-kuvertlagen-navy-bla"],
      lagenFarver: [
        {name:"Navy blå",tone:"deep",img:"silke-kuvertlagen-navy-bla-3788778.jpg?v=1763019877"}
      ],
      lagenTyper: [{id:"box",l:"Boxlagen",s:"35 cm - om hele madrassen"},{id:"kuvert",l:"Kuvertlagen",s:"20 cm - til topmadrassen"}],
      lagenStr: [{v:"90×200"},{v:"180×200"}],
      pb: ["silke-pudebetraek-ivory","silke-pudebetraek-mocca"],
      pbFarver: [
        {name:"Ivory",tone:"light",img:"silke-pudebetraek-ivory-518664.jpg?v=1736773598"},
        {name:"Mocca",tone:"warm",img:"silke-pudebetraek-mocca-534024.jpg?v=1736773598"}
      ],
      pbStr: [{v:"60×63"}]
    },

    /* Hoer: der kommer ingen hoerlagner, saa vi tilbyder det egyptiske
       kuvertlagen som matchende lagen. lagenMateriale sikrer at det bliver
       kaldt ved sit rigtige navn i teksten. Hoerpudebetraek findes ikke, og
       den raekke er fortsat skjult. */
    hor: {
      box: null,
      kuvert: ["egyptisk-bomuld-kuvertlagen-hvid","egyptisk-bomuld-kuvertlagen-sand","egyptisk-bomuld-kuvertlagen-shitake"],
      lagenMateriale: "Egyptisk bomuld",
      lagenFarver: [
        {name:"Hvid",tone:"light",img:"Egyptisk_bomuld_kuvertlagen_i_hvid_-_Nordic_Weaving.png?v=1787903354"},
        {name:"Sand",tone:"warm",img:"Egyptisk_bomuld_kuvertlagen_Sand.png?v=1787042368"},
        {name:"Shitake",tone:"warm",img:"Egyptisk_bomuld_kuvertlagen_Shitake.png?v=1787042367"}
      ],
      lagenTyper: [{id:"kuvert",l:"Kuvertlagen",s:"20 cm i egyptisk bomuld - hør findes ikke som lagen"}],
      lagenStr: [{v:"90×200"},{v:"180×200"}],
      pb: null, pbFarver: [], pbStr: []
    }
  };

  function konf(mat){ return T[mat] || T.bambus; }

  /* Eksponeres til nw-sg-priser.js, nw-sg-kurv.js, nw-sg-lager.js,
     nw-sg-komplet.js og nw-sg-tekst.js, saa alle bruger de samme handles og
     ikke kan komme ud af trit. */
  window.nwSgTilvalg = {
    konf: konf,
    lagenHandles: function(mat, type){ var k = konf(mat); return k[type === 'kuvert' ? 'kuvert' : 'box']; },
    pbHandles: function(mat){ return konf(mat).pb; },
    harLagen: function(mat){ var k = konf(mat); return !!(k.box || k.kuvert); },
    harPb: function(mat){ return !!konf(mat).pb; },
    /* Navnet paa lagenets EGET materiale, naar det afviger fra saettets. */
    lagenMateriale: function(mat){ return konf(mat).lagenMateriale || null; }
  };

  /* Erstat indholdet af en const-array uden at reassigne bindingen. */
  function erstat(arr, nye){
    if(!arr || !nye){ return false; }
    var foer = JSON.stringify(arr);
    arr.length = 0;
    nye.forEach(function(x){ arr.push(JSON.parse(JSON.stringify(x))); });
    return JSON.stringify(arr) !== foer;
  }

  var sidsteMat = null;

  function skjulCss(){
    if(document.getElementById('nw-sg-skjul')){ return; }
    var s = document.createElement('style');
    s.id = 'nw-sg-skjul';
    s.textContent = '#nwsg.nw-uden-lagen #addons .aitem:has([data-a="lagen-toggle"]){display:none}' +
                    '#nwsg.nw-uden-pb #addons .aitem:has([data-a="pb-row"]){display:none}';
    document.head.appendChild(s);
  }

  function markerSkjul(mat){
    var host = document.getElementById('nwsg');
    if(!host){ return; }
    var k = konf(mat);
    host.classList.toggle('nw-uden-lagen', !(k.box || k.kuvert));
    host.classList.toggle('nw-uden-pb', !k.pb);
  }

  function anvend(){
    try{
      if(typeof chosen === 'undefined' || !chosen || !chosen.mat){ return false; }
      var mat = chosen.mat;
      markerSkjul(mat);
      if(mat === sidsteMat){ return false; }
      var k = konf(mat);
      var aendret = false;

      if(k.lagenFarver && k.lagenFarver.length){ aendret = erstat(lagenColors, k.lagenFarver) || aendret; }
      if(k.pbFarver && k.pbFarver.length){ aendret = erstat(pudeColors, k.pbFarver) || aendret; }
      if(k.lagenTyper && k.lagenTyper.length){ aendret = erstat(lagenTypes, k.lagenTyper) || aendret; }

      /* Stoerrelsesraekker: behold pris-felterne, nw-sg-priser.js fylder dem. */
      if(k.lagenStr && k.lagenStr.length){
        var nyeL = k.lagenStr.map(function(r){ return { v: r.v, box: 0, kuvert: 0 }; });
        aendret = erstat(lagenSizes, nyeL) || aendret;
      }
      if(k.pbStr && k.pbStr.length){
        var nyeP = k.pbStr.map(function(r){ return { v: r.v, price: 0 }; });
        aendret = erstat(pbSizes, nyeP) || aendret;
      }

      /* Hold indeks og valg indenfor det nye sortiment. */
      if(chosen.lagen){
        if(chosen.lagen.ci >= lagenColors.length){ chosen.lagen.ci = 0; aendret = true; }
        if(k.lagenTyper && k.lagenTyper.length && !k.lagenTyper.some(function(t){ return t.id === chosen.lagen.type; })){
          chosen.lagen.type = k.lagenTyper[0].id; aendret = true;
        }
        if(lagenSizes.length && !lagenSizes.some(function(r){ return r.v === chosen.lagen.size; })){
          chosen.lagen.size = lagenSizes[lagenSizes.length - 1].v; aendret = true;
        }
        if(!(k.box || k.kuvert) && chosen.lagen.on){ chosen.lagen.on = false; aendret = true; }
      }
      if(chosen.pb){
        if(chosen.pb.ci >= pudeColors.length){ chosen.pb.ci = 0; aendret = true; }
        if(pbSizes.length && !pbSizes.some(function(r){ return r.v === chosen.pb.size; })){
          chosen.pb.size = pbSizes[0].v; aendret = true;
        }
        if(!k.pb && chosen.pb.qty > 0){ chosen.pb.qty = 0; aendret = true; }
      }

      sidsteMat = mat;
      return aendret;
    }catch(e){ return false; }
  }

  var hooket = false;
  function hook(){
    if(hooket || typeof window.renderResult !== 'function'){ return; }
    hooket = true;
    skjulCss();
    var f = window.renderResult;
    window.renderResult = function(){
      anvend();
      var r = f.apply(this, arguments);
      if(window.nwPrisPass){ try{ window.nwPrisPass(); }catch(e){} }
      return r;
    };
  }

  window.nwSgTilvalgPas = anvend;

  hook();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', hook); }
  window.addEventListener('load', hook);
  setTimeout(hook, 1500);
  setTimeout(hook, 3500);
})();